export default "__VITE_ASSET__8bf6e60d__"